import React, { useEffect, useState } from "react";
//internal and external components import
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import {
  TableRow,
  Chip,
  TextField,
  ThemeProvider,
  createTheme,
  Tooltip,
} from "@mui/material";
import { stableSort, getComparator } from "../../common/SortSupport";
import { EnhancedTableHead } from "../EnhancedTableHead";
import { Box } from "@mui/material";
import { AvatarAndName } from "../AvatarAndName";
import StatusIndicatorSmall from "../StatusIndicatorSmall";
import logo from "../../assets/icons/JLogo.svg";
import SelectBoxPrimary from "../SelectBoxPrimary";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faXmark,
  faCheck,
  faLinkSlash,
  faEyeSlash,
  faTrash,
  faEye,
  faLock,
} from "@fortawesome/free-solid-svg-icons";
import ActionDetailPopper from "../../containers/ActionDetailPopper";
import DateSelector from "../DateSelector";
import TableSkeleton from "../TableSkeleton";
import { SwitchButton } from "../SwitchButton";
import {
  evaluationSelectedCriteriaActionsRegex,
  evaluationSelectedStandardsActionsRegex,
  formatDate,
  genUID,
  licenceSelectedCriteriaActionsRegex,
  licenceSelectedStandardsActionsRegex,
} from "../../common/StaticExports";
import { useDispatch, useSelector } from "react-redux";
import ActionSelectBox from "../SearchSelectBox/ActionSelectBox";
import StaffSelectBox from "../SearchSelectBox/StaffSelectBox";
import { archiveAction, deleteAction, updateActions } from "../../api/action";
import {
  setCriteriaActions,
  setSaActions,
} from "../../redux/reducers/evaluation";
import NestedThreeDotMenu from "../NestedThreeDotMenu";
import AutoComplete from "../AutoComplete";
import { unassignAction } from "../../api/standards";
import { baseUrl } from "../../api/config";
import { restrictCriteriaUsersLicence, restrictStandardUsersLicence, updateActionsLicence } from "../../api/licence";
import {
  setLicenceCriteriaActions,
  setLicenceStandardsActions,
} from "../../redux/reducers/licence";
import { useTranslation } from "react-i18next";
import {
  resetAlertPopup,
  setAlertPopup,
  setSnackBarData,
} from "../../redux/reducers/common";
import AlertPopup from "../AlertPopup";
import { useLocation, useNavigate } from "react-router";
import AccessManager from "../../containers/AccessManager";
import { restrictActionUsers, restrictCriteriaUsers, restrictStandardUsers } from "../../api/evaluation";
import "./styles.css";
import { formatISO } from "date-fns";

const theme = createTheme({
  components: {
    MuiTableCell: {
      styleOverrides: {
        root: {
          padding: "6px 16px",
        },
      },
    },
    MuiStack: {
      styleOverrides: {
        root: {
          display: "inline",
          width: "90px",
        },
      },
    },
    MuiTextField: {
      styleOverrides: {
        root: {
          minWidth: "90px !important",
        },
      },
    },
    MuiInputBase: {
      styleOverrides: {
        input: {
          fontSize: 12,
        },
      },
    },
    MuiSvgIcon: {
      styleOverrides: {
        root: {
          width: 18,
          height: 18,
        },
      },
    },
  },
});

const ActionsTable = (props: any) => {
  const {
    data,
    head,
    isAction,
    addAction,
    handleClick,
    isLoading,
    isAddLoading,
    currentStandard,
    bg,
    module,
    manageCRUD,
    initialNewAction,
  } = props;
  const [t] = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();
  //supporting contents
  const [order, setOrder] = React.useState("");
  const [orderBy, setOrderBy] = React.useState("");

  const [openActionDetail, setOpenActionDetail] = React.useState(false);
  const isAdmin = useSelector((state: any) => state.common.isAdmin);
  const drawer = useSelector((state: any) => state.common.drawer);
  const licenceCriteriaActions = useSelector(
    (state: any) => state.licence.criteriaActions,
  );
  const criteriaActions = useSelector(
    (state: any) => state.evaluation.actionsList,
  );
  const selectedStandard = useSelector(
    isAdmin
      ? (state: any) => state.evaluation.selctedOffSiteStandard
      : (state: any) => state.evaluation.selectedSaStandard,
  );
  const selectedLicenceStandard = useSelector(
    (state: any) => state.licence.selectedLicenceStandard,
  );
  const currentEvalCriteria = useSelector(
    (state: any) => state.evaluation.selectedSaCriteria,
  );
  const selectedLicenceCriteria = useSelector(
    (state: any) => state.licence.selectedLicenceCriteria,
  );
  const [actionList, setActionList] = useState(() => {
    if (drawer == "Evaluation") {
      return criteriaActions;
    } else if (drawer === "Licence") {
      return licenceCriteriaActions;
    } else return [];
  });
  const staffList = useSelector((state: any) => state.evaluation.staffList);
  const projectList = useSelector((state: any) => state.evaluation.projectList);
  const departmentList = useSelector(
    (state: any) => state.evaluation.departmentList,
  );
  // const newAction = useSelector((state:any) => state.evaluation.newSaAction);
  const licenceStandardsActions = useSelector(
    (state: any) => state.licence.standardsActions,
  );
  const clubDetails = useSelector((state: any) => state.clubDetails);
  const standardsList = useSelector((state: any) =>
    drawer === "Licence"
      ? state.licence.licenceCriteriaStandards
      : isAdmin
        ? state.evaluation.offSiteStandards
        : state.evaluation.saStandards,
  );
  const initialAction = initialNewAction
    ? initialNewAction
    : {
        name: "",
        description: "",
        dueDate: null,
        ragb: 4,
        ownerName: "",
        ownerUserId: null,
        isCreatedByJL: isAdmin,
        isArchived: false,
        isAlreadyComplete: false,
        projectName: "",
        projectId: null,
        departmentName: "",
        departmentId: null,
        standardHistory: [],
      };
  const [newAction, setNewAction]: any = useState(initialAction);
  const [newlyAddedAction, setNewlyAddedAction]: any = useState(initialAction);
  const actionDeletePopupInitialData = {
    isOpen: false,
    actionToDelete: null,
    alertMessage: "",
  };
  const actionArchivePopupInitialData = {
    isOpen: false,
    actionToArchive: null,
    alertMessage: "",
  };
  const [actionDeletePopup, setActionDeletePopup]: any = useState(
    actionDeletePopupInitialData,
  );
  const [actionArchivePopup, setActionArchivePopup]: any = useState(
    actionArchivePopupInitialData,
  );
  const dispatch = useDispatch();
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const threeDotMenuOptions = isAction
    ? [
        { label: "Archive Action", icon: faEyeSlash, isDisabled: false },
        { label: "Delete Action", icon: faTrash, isDisabled: false },
        { label: "Manage Access", icon: faLock, isDisabled: false },
      ]
    : [
        { label: "Unlink Action", icon: faLinkSlash, isDisabled: false },
        { label: "Archive Action", icon: faEyeSlash, isDisabled: false },
        { label: "Delete Action", icon: faTrash, isDisabled: false },
        { label: "Manage Access", icon: faLock, isDisabled: false },
      ];
  const [actionData, setActionData]: any = useState(null);
  const initialAccessState = {
    isOpen: false,
    itemId: null,
  }
  const [manageAccess, setManageAccess] = React.useState(initialAccessState);

  const fetchThreeDotMenuOptions: any = (rowData: any) => {
    if (
      isAdmin &&
      rowData?.isCreatedByJL &&
      (module == "LICENCE" || module == "licence")
    ) {
      return [
        {
          label: rowData?.licenceJLActionStatus
            ? "UNISSUE_ADMIN_ACTION"
            : "ISSUE_ADMIN_ACTION",
          icon: faEye,
          isDisabled: false,
        },
        { label: "Unlink Action", icon: faLinkSlash, isDisabled: true },
        { label: "Archive Action", icon: faEyeSlash, isDisabled: true },
        {
          label: "Delete Action",
          icon: faTrash,
          isDisabled: rowData?.licenceJLActionStatus,
        },
      ];
    } else if (isAdmin && rowData?.isCreatedByJL && !isAction) {
      return [
        { label: "Unlink Action", icon: faLinkSlash, isDisabled: false },
        { label: "Archive Action", icon: faEyeSlash, isDisabled: true },
        { label: "Delete Action", icon: faTrash, isDisabled: false },
      ];
    }
    return threeDotMenuOptions;
  };

  const handleRequestSort = (
    event: React.MouseEvent<unknown>,
    property: any,
  ) => {
    const isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
  };

  const visibleRows: any = React.useMemo(
    () =>
      data?.length > 0 ? stableSort(data, getComparator(order, orderBy)) : [],
    [order, orderBy, data],
  );

  useEffect(() => {
    if (
      !actionData &&
      !openActionDetail &&
      (licenceSelectedCriteriaActionsRegex.test(location.pathname) ||
        evaluationSelectedCriteriaActionsRegex.test(location.pathname) ||
        licenceSelectedStandardsActionsRegex.test(location.pathname) ||
        evaluationSelectedStandardsActionsRegex.test(location.pathname))
    ) {
      const tempArr = location.pathname.split("/");
      const tempActionId = tempArr[tempArr?.length - 1];
      const tempActionData =
        data && data?.length > 0
          ? data?.find((d: any) => d.id == tempActionId)
          : { id: tempActionId };
      setActionData(tempActionData);
      setOpenActionDetail(true);
    }
  }, [location.pathname]);

  const manageCreateClick = () => {
    const createAction = async (data: any) => {
      const response = await updateActions(data).then(() => {
        const warningData: any = {
          isOpen: true,
          severity: "success",
          message: t("ACTION_CREATED_SUCCESSFULLY"),
        };
        dispatch(setSnackBarData(warningData));
      });
      return response;
    };

    if (
      newAction.name != "" &&
      newAction.name != undefined &&
      clubDetails?.id &&
      (currentStandard?.id || isAction)
    ) {
      if (isAction) {
        manageCRUD("create", newAction);
        // if(!(newAction && Object.keys(newAction).includes('id'))) {
        //   // var actionArr:any = [];
        //   // var p:any = {};
        //   // switch(module || drawer) {
        //   //   case 'LICENCE':
        //   //   case 'licence':
        //   //   case 'Licence':
        //   //     const tempNewAction = {
        //   //       ...newAction,
        //   //       isCreatedByJL: true,
        //   //       licenceJLActionStatus: false
        //   //     }
        //   //     actionArr = data.filter((a:any) => {return a.standardHistory?.some((sh:any) => sh.standardId == newAction?.standardHistory[0].id)});
        //   //     actionArr = [...actionArr, newAction];
        //   //     p = {
        //   //       clubId: clubDetails.id,
        //   //       standardId: newAction?.standardHistory[0].id,
        //   //       actions: actionArr
        //   //     };
        //   //     const response = updateActionsLicence(p);
        //   //     break;
        //   //   default:
        //   //     manageCRUD('create', newAction);
        //   // }
        // } else {
        //   var newActionStandard:any = newAction?.standardHistory[0];
        //   var tempArr = data.filter((a:any) => {return a.standardHistory.some((sh:any) => sh.standardId == newActionStandard.id)});
        //   tempArr = [...tempArr, newAction];
        //   const parameters = {
        //     clubId: clubDetails?.id,
        //     standardId: newActionStandard?.id,
        //     actions: tempArr
        //   }
        //   createAction(parameters).then((res) => {
        //     if (res !== undefined && Array.isArray(res) && res.length > 0) {
        //       newAction?.standardHistory?.forEach((na:any, index:number) => {
        //         if(index > 0) {
        //           var arr01 = data.filter((a:any) => {return a.standardHistory.some((sh:any) => sh.standardId == na.id)});
        //           arr01 = [...arr01, res[0]];
        //           createAction({clubId: clubDetails?.id, standardId: na.id, actions: arr01}).then((ress) => {
        //             if(index == newAction?.standardHistory?.length - 1) {
        //               handleClick(true);
        //             }
        //           })
        //         }
        //       })
        //     }
        //     if(newAction?.standardHistory?.length == 1) {
        //       handleClick(true);
        //     }
        //   });
        // }
      } else {
        manageCRUD("create", newAction);
        // var actionArr:any = [];
        // var parameters:any = {};
        // switch(module || drawer) {
        //   case 'LICENCE':
        //   case 'licence':
        //   case 'Licence':
        //     const tempNewAction = {
        //       ...newAction,
        //       isCreatedByJL: true,
        //       licenceJLActionStatus: false
        //     }
        //     actionArr = [...licenceStandardsActions, tempNewAction];
        //     parameters = {
        //       clubId: clubDetails.id,
        //       actions: actionArr,
        //       standardId: currentStandard.id,
        //     }
        //     const response = updateActionsLicence(parameters);
        //     dispatch(setLicenceStandardsActions(response));
        //     handleClick(true);
        //     break;
        //   default:
        //     actionArr = [...data, newAction];
        //     parameters = {
        //       clubId: clubDetails.id,
        //       standardId: currentStandard.id,
        //       actions: actionArr
        //     }
        //     createAction(parameters).then((res) => {
        //       dispatch(setSaActions(res));
        //       handleClick(true);
        //     });
        // }
      }
    }
  };

  const manageStandardSelect = (stand: any) => {
    const index = newAction?.standardHistory?.findIndex(
      (obj: any) => obj.id == stand.id,
    );
    let tempArr: any = newAction?.standardHistory
      ? [...newAction?.standardHistory]
      : [];
    if (index !== -1) {
      tempArr?.splice(index, 1);
    } else {
      tempArr?.push(stand);
    }
    setNewAction({ ...newAction, standardHistory: tempArr });
  };

  const manageLicenceActionDelete = (action: any) => {
    const index = licenceStandardsActions.findIndex(
      (obj: any) => obj.id == action.id || !("id" in action),
    );
    let tempArr: any = licenceStandardsActions;
    if (index !== -1) {
      tempArr = licenceStandardsActions.filter((d: any, i: any) => i != index);
    }
    const parameters = {
      clubId: clubDetails.id,
      actions: tempArr,
      standardId: currentStandard.id,
    };
    const response = updateActionsLicence(parameters);
    dispatch(setLicenceStandardsActions(response));
  };

  const manageHandleCloseDelete = (isConfirm: any) => {
    if (isConfirm) {
      manageCRUD("delete", actionDeletePopup?.actionToDelete?.id);
      // !(actionDeletePopup?.actionToDelete?.isCreatedByJL && isAdmin) &&
      deleteAction({ actionId: actionDeletePopup?.actionToDelete?.id }).then(
        () => {
          setActionDeletePopup(actionDeletePopupInitialData);
          const warningData: any = {
            isOpen: true,
            severity: "success",
            message: t("ACTION_DELETED_SUCCESSFULLY"),
          };
          dispatch(setSnackBarData(warningData));
        },
      );
    }
    setActionDeletePopup(actionDeletePopupInitialData);
    setAnchorEl(null);
  };

  const manageHandleCloseArchive = (isConfirm: any) => {
    if (isConfirm) {
      manageCRUD("archive", actionArchivePopup?.actionToArchive?.id);
      archiveAction({ actionId: actionArchivePopup?.actionToArchive?.id }).then(
        () => {
          const warningData: any = {
            isOpen: true,
            severity: "success",
            message: t("ACTION_ARCHIVED_SUCCESSFULLY"),
          };
          dispatch(setSnackBarData(warningData));
        },
      );
    }
    setActionArchivePopup(actionArchivePopupInitialData);
    setAnchorEl(null);
  };

  const handleThreedotMenuClick = (selctedAction: any, action: any) => {
    switch (selctedAction) {
      case "Delete Action":
        const deleteTempAlertPopup: any = {
          isOpen: true,
          alertMessage: t("DELETE_ACTION_CONFIRMATION"),
          actionToDelete: action,
        };
        setActionDeletePopup(deleteTempAlertPopup);
        handleClick(true);
        break;
      case "Archive Action":
        const tempAlertPopup: any = {
          isOpen: true,
          alertMessage: t("ARCHIVE_ACTION_CONFIRMATION"),
          actionToArchive: action,
        };
        setActionArchivePopup(tempAlertPopup);
        handleClick(true);
        break;
      case "Unlink Action":
        manageCRUD("unlink", action?.id);
        unassignAction({
          actionId: action?.id,
          standardId: currentStandard?.id,
        }).then(() => {
          const warningData: any = {
            isOpen: true,
            severity: "success",
            message: t("ACTION_UNLINKED_SUCCESSFULLY"),
          };
          dispatch(setSnackBarData(warningData));
        });
        break;
      case "UNISSUE_ADMIN_ACTION":
      case "ISSUE_ADMIN_ACTION":
        manageCRUD("issue_unissue", action);
        break;
      case "Manage Access":
        const tempAccessData = {
          isOpen: true,
          itemId: action?.id,
        }
        setManageAccess(tempAccessData);
        break;
    }
  };
  
  const manageUserAccess = (isUpdated: any, restrictedUsers:any, newUnRestrictedUsers?: any) => {
    if (isUpdated) {
        if (newUnRestrictedUsers && newUnRestrictedUsers?.length > 0 && currentStandard == null) {
          var criteriaData = drawer == "Evaluation" ? currentEvalCriteria : selectedLicenceCriteria;
          var criteriaRestrictedUserIds = criteriaData?.restrictions?.filter((res:any) => res.isRestricted)?.map((x:any) => x.userId) || [];
          var updatedActionUsers = newUnRestrictedUsers ? criteriaRestrictedUserIds?.filter((num:any) => !newUnRestrictedUsers?.includes(num)) : restrictedUsers;
          drawer == "Evaluation" ?
          restrictCriteriaUsers({clubId: clubDetails?.id, criteriaId: currentEvalCriteria?.id, users: updatedActionUsers}):
          restrictCriteriaUsersLicence({clubId: clubDetails?.id, criteriaId: selectedLicenceCriteria?.id, users: updatedActionUsers});
        }
        if (newUnRestrictedUsers && newUnRestrictedUsers?.length > 0 && currentStandard != null) {
          var standardsRestrictedUserIds = currentStandard?.restrictions?.filter((res:any) => res.isRestricted)?.map((x:any) => x.userId) || [];
          var updatedStandardUsers = newUnRestrictedUsers ? standardsRestrictedUserIds?.filter((num:any) => !newUnRestrictedUsers?.includes(num)) : restrictedUsers;
          drawer == "Evaluation" ? 
          restrictStandardUsers({clubId: clubDetails?.id, criteriaId: currentEvalCriteria?.id, users: updatedStandardUsers}) :
          restrictStandardUsersLicence({clubId: clubDetails?.id, criteriaId: selectedLicenceCriteria?.id, users: updatedStandardUsers});
        }
        restrictActionUsers({clubId: clubDetails?.id, id: manageAccess?.itemId, users: restrictedUsers})
        .then(() => {
        })
        .catch((error:any) => {
          const warningData: any = {
            isOpen: true,
            severity: "error",
            message: error?.message || t("ACCESS_UPDATE_FAILED"),
          };
          dispatch(setSnackBarData(warningData));
        });
    }
    setManageAccess(initialAccessState);
  };

  const manageActionDetailClose = (actionupdated: any) => {
    if (
      actionupdated &&
      Object.keys(actionupdated).length > 0 &&
      actionupdated?.id
    ) {
      manageCRUD("update", actionupdated);
    }
    setActionData(null);
    setOpenActionDetail(false);
    openActionDetail && manageCloseNavigation();
  };

  const manageNavigation = (actionItem: any) => {
    switch (module) {
      case t("EVALUATION"):
        isAction
          ? navigate(
              `/evaluation/criteria/${currentEvalCriteria?.id}/actions/${actionItem?.id}`,
            )
          : navigate(
              `/evaluation/criteria/${currentEvalCriteria?.id}/standards/${currentStandard?.id}/actions/${actionItem?.id}`,
            );
        setActionData(actionItem);
        setOpenActionDetail(true);
        break;
      case t("LICENCE"):
      case "licence":
      case "Licence":
      case "LICENCE":
        isAction
          ? navigate(
              `/licence/criteria/${selectedLicenceCriteria?.id}/actions/${actionItem?.id}`,
            )
          : navigate(
              `/licence/criteria/${selectedLicenceCriteria?.id}/standards/${currentStandard?.id}/actions/${actionItem?.id}`,
            );
        setActionData(actionItem);
        setOpenActionDetail(true);
        break;
    }
  };

  const manageCloseNavigation = () => {
    setOpenActionDetail(false);
    switch (module) {
      case t("EVALUATION"):
        !selectedStandard
          ? navigate(`/evaluation/criteria/${currentEvalCriteria?.id}/actions`)
          : navigate(
              `/evaluation/criteria/${currentEvalCriteria?.id}/standards/${selectedStandard?.id}`,
            );
        break;
      case t("LICENCE"):
      case "licence":
      case "Licence":
      case "LICENCE":
        !selectedLicenceStandard
          ? navigate(`/licence/criteria/${selectedLicenceCriteria?.id}/actions`)
          : navigate(
              `/licence/criteria/${selectedLicenceCriteria?.id}/standards/${selectedLicenceStandard?.id}`,
            );
        break;
    }
  };

  //table contents
  return (
    <React.Fragment>
      <ThemeProvider theme={theme}>
        <Box sx={{ position: "relative", height: "100%" }}>
          <ActionDetailPopper
            isOpen={openActionDetail}
            handleIsOpen={manageActionDetailClose}
            data={actionData}
            isReadOnly={!actionData?.isCreatedByJL && isAdmin}
            module={module}
          />
          <AccessManager
            isOpen={manageAccess?.isOpen}
            handleIsOpen={manageUserAccess}
            from={"actions"}
            itemId={manageAccess?.itemId}
            criteriaRestrictions={currentStandard && currentStandard?.restrictions
              ? [...(currentEvalCriteria?.restrictions ?? []), ...(currentStandard?.restrictions ?? [])]
              : (currentEvalCriteria?.restrictions ?? [])}
          />
          <TableContainer sx={{ height: "100%", overflowY: "auto" }}>
            <Table className="actionTable" stickyHeader size="small" aria-label="a dense table">
              <EnhancedTableHead
                order={order}
                orderBy={orderBy}
                onRequestSort={handleRequestSort}
                tableHeads={head}
                bg={bg}
              />
              <TableBody>
                {!isAddLoading && addAction ? (
                  <TableRow
                    sx={{ cursor: "pointer" }}
                    key={`actions-table-row-create`}
                  >
                    <TableCell className="fs12">
                      {isAdmin && (
                        <img
                          className="smallLogoForTables"
                          style={{ marginTop: "0px" }}
                          src={logo}
                          alt="JL Logo"
                        />
                      )}
                    </TableCell>
                    <TableCell className="fs12">
                      {/* <StatusIndicatorSmall reportType={''} status={d.status} /> */}
                      <SelectBoxPrimary
                        label={""}
                        options={[0, 1, 2, 3, 4]}
                        isStatus={true}
                        selected={newAction.ragb ? newAction.ragb : 0}
                        report={"rabg"}
                        disabled={isAdmin}
                        manageChange={(e: any) => {
                          setNewAction({ ...newAction, ragb: e });
                        }}
                      />
                    </TableCell>
                    <TableCell className="fs12">
                      <ActionSelectBox
                        optionList={actionList}
                        variant={"standard"}
                        selected={newAction.name}
                        manageActionSelect={(data: any) => {
                          if (data && Object.keys(data).includes("id")) {
                            setNewAction({
                              ...data,
                              id: null,
                              standardHistory: [],
                            });
                          } else {
                            setNewAction({ ...newAction, ...data });
                          }
                        }}
                      />
                    </TableCell>
                    <TableCell className="fs12">
                      <TextField
                        variant="standard"
                        value={newAction.description}
                        onChange={(e) => {
                          setNewAction({
                            ...newAction,
                            description: e.target.value,
                          });
                        }}
                      />
                    </TableCell>
                    {isAction && (
                      <TableCell className="fs12">
                        <Box sx={{ width: "250px" }}>
                          <AutoComplete
                            options={standardsList || []}
                            selectedValues={newAction?.standardHistory || []}
                            key={"uid"}
                            handleMenuClick={(d: any) => {
                              manageStandardSelect(d);
                            }}
                            clickReset={() => {
                              setNewAction({ ...newAction });
                            }}
                            isMultiple={true}
                            variant={"standard"}
                          />
                        </Box>
                      </TableCell>
                    )}
                    <TableCell className="fs12">
                      <Box sx={{ width: "120px" }}>
                        <DateSelector
                          variant="standard"
                          dateValue={
                            newAction.dueDate
                              ? formatDate(newAction.dueDate)
                              : null
                          }
                          manageChange={(e: any) => {
                            setNewAction({
                              ...newAction,
                              dueDate: e ? formatISO(new Date(e)) : null,
                            });
                          }}
                        />
                      </Box>
                    </TableCell>
                    <TableCell className="fs12">
                      <Box sx={{ width: "120px" }}>
                        <StaffSelectBox
                          options={staffList}
                          variant={"standard"}
                          selectedValue={newAction.ownerUserId}
                          disabled={isAdmin}
                          manageSelect={(data: any) => {
                            setNewAction({
                              ...newAction,
                              ownerName: data.displayName,
                              ownerUserId: data.id,
                            });
                          }}
                        />
                      </Box>
                    </TableCell>
                    {isAction && (
                      <TableCell className="fs12">
                        <StaffSelectBox
                          options={departmentList}
                          variant={"standard"}
                          selectedValue={newAction.projectId}
                          disabled={isAdmin}
                          manageSelect={(e: any) => {
                            setNewAction({
                              ...newAction,
                              departmentName: e.name,
                              departmentId: e.id,
                            });
                          }}
                        />
                      </TableCell>
                    )}
                    {isAction && (
                      <TableCell className="fs12">
                        <StaffSelectBox
                          options={projectList}
                          variant={"standard"}
                          selectedValue={newAction.projectId}
                          disabled={isAdmin}
                          manageSelect={(e: any) => {
                            setNewAction({
                              ...newAction,
                              projectName: e.displayName,
                              projectId: e.id,
                            });
                          }}
                        />
                      </TableCell>
                    )}
                    <TableCell>
                      <Box sx={{ display: "flex" }}>
                        <Tooltip title="Delete" arrow placement="top">
                          <FontAwesomeIcon
                            onClick={() => {
                              setNewAction(initialAction);
                              handleClick(false);
                            }}
                            className={"icon mr10"}
                            icon={faXmark}
                          />
                        </Tooltip>
                        <Tooltip title="Create" arrow placement="top">
                          <FontAwesomeIcon
                            onClick={() => {
                              manageCreateClick();
                            }}
                            className={"icon mr10"}
                            icon={faCheck}
                          />
                        </Tooltip>
                      </Box>
                    </TableCell>
                  </TableRow>
                ) : (
                  isAddLoading && (
                    <TableSkeleton rowCount={1} cellCount={head?.length} />
                  )
                )}
                {!isLoading && visibleRows?.length ? (
                  visibleRows.map((d: any, i: number) => {
                    var standards =
                      module == "licence"
                        ? d.licenceStandardHistory
                        : d.standardHistory;
                    return (
                      <TableRow
                        sx={{ cursor: "pointer" }}
                        key={`actions-table-row-${i}`}
                        onClick={() => {
                          // setActionData(d);
                          // setOpenActionDetail(true);
                          manageNavigation(d);
                        }}
                      >
                        <TableCell className="fs12">
                          {d?.isCreatedByJL && (
                            <img
                              className="smallLogoForTables"
                              style={{ marginTop: "0px" }}
                              src={logo}
                              alt="JL Logo"
                            />
                          )}
                        </TableCell>
                        <TableCell className="fs12">
                          <StatusIndicatorSmall
                            reportType={"rabg"}
                            status={d.ragb}
                          />
                        </TableCell>
                        <TableCell className="fs12">
                          {d.name?.length > 40
                            ? d.name.slice(0, 40) + "..."
                            : d.name}
                        </TableCell>
                        <TableCell className="fs12">
                          {d.description?.length > 60
                            ? d.description.slice(0, 60) + "..."
                            : d.description != undefined &&
                                d.description != null
                              ? d.description
                              : ""}
                        </TableCell>
                        {isAction && (
                          <TableCell className="fs12" sx={{ minWidth: 125 }}>
                            {standards?.length > 0 ? (
                              standards?.length == 1 ? (
                                <Chip
                                  className="chipStyle"
                                  label={genUID(standards[0].uid)}
                                  color="primary"
                                />
                              ) : (
                                <Box>
                                  <Chip
                                    className="chipStyle"
                                    label={genUID(standards[0].uid)}
                                    color="primary"
                                  />
                                  <Tooltip
                                    title={standards
                                      .map((obj: any) => genUID(obj.uid))
                                      .join(", ")}
                                    arrow
                                    placement="top"
                                  >
                                    <Chip
                                      className="chipStyle"
                                      sx={{ ml: "0px !important" }}
                                      label={"+" + (standards.length - 1)}
                                      color="primary"
                                    />
                                  </Tooltip>
                                </Box>
                              )
                            ) : (
                              ""
                            )}
                          </TableCell>
                        )}
                        <TableCell className="fs12" sx={{ minWidth: 80 }}>
                          {d.dueDate ? formatDate(d.dueDate) : "-"}
                        </TableCell>
                        <TableCell className="fs12">
                          {d?.ownerName ? (
                            <AvatarAndName
                              avatarName={d.ownerName}
                              avatarImage={
                                d.ownerAvatarPath
                                  ? `${baseUrl}/Content${d.ownerAvatarPath}`
                                  : ""
                              }
                            />
                          ) : (
                            "_"
                          )}
                        </TableCell>
                        {isAction && (
                          <TableCell className="fs12">
                            {d.departmentName}
                          </TableCell>
                        )}
                        {isAction && (
                          <TableCell className="fs12">
                            {d.projectName}
                          </TableCell>
                        )}
                        <TableCell
                          sx={{ width: "1px" }}
                          onClick={(e: any) => {
                            e.stopPropagation();
                          }}
                        >
                          {((d?.isCreatedByJL && isAdmin) ||
                            (!d?.isCreatedByJL && !isAdmin)) && (
                            <Box
                              className="alertBoxParent"
                              onClick={(e: any) => {
                                setAnchorEl(e.currentTarget);
                              }}
                            >
                              <AlertPopup
                                alertMessage={actionDeletePopup?.alertMessage}
                                isOpen={actionDeletePopup?.isOpen}
                                handleClose={(isDelete: any) => {
                                  manageHandleCloseDelete(isDelete);
                                }}
                                anchor={anchorEl}
                              />
                              <AlertPopup
                                alertMessage={actionArchivePopup?.alertMessage}
                                isOpen={actionArchivePopup?.isOpen}
                                handleClose={(isArchive: any) => {
                                  manageHandleCloseArchive(isArchive);
                                }}
                                anchor={anchorEl}
                              />
                              <NestedThreeDotMenu
                                options={fetchThreeDotMenuOptions(d)}
                                manageClick={(e: any) => {
                                  handleThreedotMenuClick(e, d);
                                }}
                              />
                            </Box>
                          )}
                        </TableCell>
                      </TableRow>
                    );
                  })
                ) : !addAction &&
                  !isLoading &&
                  (visibleRows?.length == 0 || visibleRows == undefined) ? (
                  <TableRow>
                    <TableCell
                      colSpan={head?.length}
                      className="fs12"
                      align="center"
                    >
                      No Action Found
                    </TableCell>
                  </TableRow>
                ) : (
                  !addAction &&
                  isLoading && (
                    <TableSkeleton rowCount={10} cellCount={head?.length} />
                  )
                )}
              </TableBody>
            </Table>
          </TableContainer>
        </Box>
      </ThemeProvider>
    </React.Fragment>
  );
};

export default ActionsTable;
